const URL = `spell-codex.tristan97little.workers.dev/`

const PATH = `spellCodex/`

const AUTH = `83H0LDM1N30R8`

export {URL, PATH, AUTH};
